import { Stack, Typography } from '@mui/material';
import {
  LoadingIndicator,
  useLanguage,
  GenericErrorComponent,
} from '@xolv-mybrightlink/common';
import { useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import { useDimensionClass } from '../hooks/useDimensionClass';
import { loadFirstPage } from '../hooks/useDimensionClassAction';
import { DimensionClassStateType } from '../hooks/useDimensionClassReducer';
import { DimensionClassList } from './DimensionClassList';

export const DimensionClassComponent = () => {
  const [state, dispatch] = useDimensionClass();
  const lang = useLanguage();

  useEffect(() => {
    loadFirstPage(dispatch, lang.language);
  }, [lang.language, dispatch]);

  return (
    <Stack sx={{ p: 10, height: '100%' }}>
      <Typography
        variant={'h6'}
        sx={{
          fontWeight: 500,
          mb: 12.5,
        }}
      >
        <FormattedMessage id='dimension-parent-class.heading' />
      </Typography>
      {[
        DimensionClassStateType.LOADED,
        DimensionClassStateType.LOAD_MORE,
      ].includes(state.currentState) &&
        state.videoList != null && (
          <DimensionClassList videoList={state.videoList} />
        )}
      {state.currentState == DimensionClassStateType.LOADING && (
        <LoadingIndicator fullHeight={true} />
      )}
      {state.currentState == DimensionClassStateType.ERROR && (
        <GenericErrorComponent />
      )}
    </Stack>
  );
};
